export default function Strategy() {
  const strategies = [
    {
      id: 1,
      icon: "ri-user-heart-line",
      title: "Protocolo Personalizado",
      description: "Planejamento individual conforme objetivo, histórico e necessidade da paciente."
    },
    {
      id: 2,
      icon: "ri-body-scan-line",
      title: "Composição Corporal",
      description: "Foco em melhora do contorno, definição, redução de medidas e equilíbrio corporal."
    },
    {
      id: 3,
      icon: "ri-flashlight-line",
      title: "Performance e Bem-estar",
      description: "Estratégias voltadas para mais disposição, constância e evolução dos resultados."
    }
  ];

  return (
    <section id="emagrecimento" className="bg-[#faf8f5] py-20 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Estratégia Individual
          </span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Emagrecimento e Performance<br />
          <span className="italic text-[#C9A84C]">com estratégia individual</span>
        </h2>

        <p className="text-[#666] text-sm sm:text-base leading-relaxed mb-12 max-w-3xl" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Cada paciente possui um objetivo, uma rotina e uma resposta corporal diferente. Por isso, os protocolos são pensados de forma personalizada, buscando melhora da composição corporal, definição, desempenho, autoestima e sustentação dos resultados ao longo do tempo.
        </p>

        {/* Strategy cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {strategies.map((strategy) => (
            <div
              key={strategy.id}
              className="bg-white border border-[#e8dfc8] rounded-2xl px-6 py-8 hover:border-[#C9A84C]/60 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#C9A84C]/10 mb-5 group-hover:bg-[#C9A84C]/20 transition-all duration-300">
                <i className={`${strategy.icon} text-[#C9A84C] text-2xl`}></i>
              </div>
              <h3 className="text-[#1a1a1a] text-lg font-semibold mb-3 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                {strategy.title}
              </h3>
              <p className="text-[#888] text-sm leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                {strategy.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}